import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import EGiftsDashboard from '../../../MarketplaceHub/EGiftsDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyEGifts } from './companyMarketplaceApi';

/** Company Marketplace → E-Gifts dashboard, scoped to this company. */
const CMarketplaceEGifts = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyEGifts(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Marketplace E-Gifts | Shoorah</title>
      </Helmet>
      <EGiftsDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CMarketplaceEGifts;
